import React from "react";

class Header extends React.Component {
  render() {
    const { logoUrl, websiteUrl } = this.props;

    return (
      <div className="header">
        <div
          className="logo"
          onClick={() => {
            window.open(websiteUrl, "_blank");
          }}
        >
          <img src={logoUrl} alt="Logo" />
        </div>
      </div>
    );
  }
}

export default Header;
